import React from 'react';
import { useDispatch } from 'react-redux';

import Modal, { ModalProps } from '@zola/zola-ui/src/components/Modal/Modal';

import { deleteEntityV2 } from 'actions/website/EntityActions';
import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';
import type { AppDispatch } from 'reducers/index';
import type { ActivePageStateType } from 'components/manage/EditWebsite/context';
import { deleteEntity } from 'components/manage/EditWebsite/api/entities';

import {
  Container,
  Title,
  Subtitle,
  StyledSecondaryButton,
  StyledPrimaryButton,
  Actions,
  ModalStyles,
} from './EditPageDeleteEntityModal.styles';

type EditPageDeleteEntityModalProps = Pick<ModalProps, 'triggerRef' | 'onClose'> & {
  entity: GenericEntityType;
  handleAfterConfirmDelete?: () => void;
  activePage?: ActivePageStateType;
};

const EditPageDeleteEntityModal = ({
  entity,
  handleAfterConfirmDelete,
  onClose,
  triggerRef,
  activePage,
}: EditPageDeleteEntityModalProps): JSX.Element => {
  const dialogHeadingId = 'delete-entity-header';
  const dispatch = useDispatch<AppDispatch>();

  const handleDeleteEntity = () =>
    (activePage
      ? deleteEntity(entity, activePage, dispatch)
      : dispatch(deleteEntityV2(entity))
    ).then(() => {
      onClose();
      if (handleAfterConfirmDelete) {
        handleAfterConfirmDelete();
      }
    });

  return (
    <Modal
      css={ModalStyles}
      onClose={onClose}
      rootId="zola-wedding-container"
      triggerRef={triggerRef}
      dialogHeadingId={dialogHeadingId}
    >
      <Container>
        <Title id={dialogHeadingId}>Confirm your changes</Title>
        <Subtitle>Are you sure you want to remove this from your website?</Subtitle>
        <Actions>
          <StyledSecondaryButton variant="secondary" onClick={onClose}>
            Cancel
          </StyledSecondaryButton>
          <StyledPrimaryButton onClick={handleDeleteEntity}>Remove</StyledPrimaryButton>
        </Actions>
      </Container>
    </Modal>
  );
};

export default EditPageDeleteEntityModal;
